import { render, staticRenderFns } from "./AddShift.vue?vue&type=template&id=b4143f5a&scoped=true&"
import script from "./AddShift.vue?vue&type=script&lang=ts&"
export * from "./AddShift.vue?vue&type=script&lang=ts&"
import style0 from "./AddShift.vue?vue&type=style&index=0&id=b4143f5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4143f5a",
  null
  
)

component.options.__file = "AddShift.vue"
export default component.exports